import React, { Component } from 'react';
import serverEndPoint from './../dxdm';

const footerCSS = {
    width: "100%",
    backgroundColor: "white",
    color: "black",
    paddingTop: "1%",
    paddingBottom: "1%"
}
export default class Footer extends Component {
    render() {
        return (
            <div style={footerCSS}>
                <div className="container">
                    <div className="row" style={{ height: "100%"}}>
                        <div className="col-sm-6" style={{marginLeft:"-160pt"}}><img alt="FAST National University" style={{ width: "150pt" }} src={`${serverEndPoint}/images/DataInsightLabLogo.png`} /></div>
                        <div className="col-sm-6" style={{ color:"rgba(200,200,200)",display:"flex",alignItems:"flex-end",justifyContent:"flex-start", fontSize:"1.4vh", fontFamily:"inherit"}}>©️ 2021. All rights reserved by Data Insight Lab, National University FAST, Islamabad, Pakistan.</div>
                    </div>
                </div>
                <div style={{marginRight:"2%",color: "gray",display:"flex",alignItems:"flex-end",justifyContent:"flex-end", fontSize:"1.4vh", fontFamily:"inherit"}}><a rel="noreferrer" target="_blank" style={{textDecoration:"none",color:"rgba(200,200,200)"}} href="https:solutionave.com">Developed by SolutionAve</a></div>

            </div>
        )
    }
}
